module.exports = __webpack_public_path__ + "je.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/je.svg
// module id = 624
// module chunks = 0